import * as R from 'ramda'

import schema from '../schema.js'

const schemaOfCollection = R.pipe(
  R.assocPath(['contents', 'items'], {
    type: 'Array',
    contents: [{ type: 'ObjectId', reference: 'retailOrderItems' }],
  }),
)(schema.header)

// One index for every award type, where there used to be one per kind. The
// sweep query is `{ 'awards.adjustingAt': { $lte: now } }` and `awards` is an
// array, so this is multikey -- one entry per element -- and a single-field
// index is all the query can use.
//
// Sparse keeps every order that never touched a loyalty platform out of the
// index entirely, which is most of them.
const index = {
  awardsAdjusting: {
    key: { 'awards.adjustingAt': 1 },
    sparse: true,
  },
  // What publicOrders/findOrders queries and how it sorts, in one index: the
  // consumer the phone resolved to, then the date it orders by. Without the
  // `date` half the sort would be a blocking in-memory sort of everything the
  // consumer matched. A date window narrows the same scan, since `date` is the
  // second key and the first is pinned to one id.
  //
  // THE OTHER HALF OF THAT READ IS INDEXED ELSEWHERE. The phone is resolved
  // against `consumers` first, and `{ phone: 1 }` is declared in
  // src/consumers/data/consumers/dbIndex -- so neither query is a collection
  // scan, and the one that runs first is not declared in this file.
  //
  // AN `$in` OF CONSUMER IDS USES THIS: one index scan per id, each already in
  // date order, merged into one ordered result. So a number held by more than
  // one consumer costs a scan per consumer -- more work than a single id, but
  // still served from the index rather than by a blocking sort.
  //
  // NOT SPARSE, unlike the one above -- and it would do nothing if it were. A
  // compound sparse index skips a document only when it has NONE of the
  // indexed fields, and `date` is on every order, so a walk-in with no
  // consumer would be indexed anyway.
  //
  // codev's bootstrap drops any index a model no longer declares, so the
  // `consumerPhone` index this replaced goes away on the next boot.
  // `_id` IS PART OF THE SORT, so it is part of the index. publicOrders pages
  // with skip/limit, and skip/limit over a sort that leaves ties in an
  // arbitrary order loses rows at the page boundary -- `date` is written to
  // the minute, so ties are ordinary. Without the third key the query would be
  // served from the index and then sorted in memory anyway.
  consumerId: {
    key: { 'consumer.id': 1, date: 1, _id: 1 },
  },
  // THE SAME READ WITHOUT A PHONE, which the index above cannot serve: a
  // compound index is usable only from its leading key, so a query naming only
  // `date` would scan the collection and then sort it in memory.
  // publicOrders/findOrders makes exactly that query when a caller asks for a
  // date window and no customer, and this serves both the range and the sort.
  date: {
    key: { date: 1, _id: 1 },
  },
}

export default {
  schema: schemaOfCollection,
  index,
}
